import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/* Styles */
import "../style/pages/trend.css";
//@ts-ignore
import { formatFloat, formatInteger } from "@utils/NumberUtils";
import { COLORS, MAP_TILER_APIKEY } from "./components/variables";
//@ts-ignore
import TrendBar from "./vue/TrendBar.vue";
//@ts-ignore
import ValuationBanner from "./vue/ValuationBanner.vue";
import axios from "axios";
//@ts-ignore
import PublicUserMenu from "./vue/PublicUserMenu.vue";
//@ts-ignore
import { useAppBanner } from "@wkComposables/useAppBanner";
//@ts-ignore
import shimmerLoader from "./vue/ShimmerLoader.vue";
//@ts-ignore
import CommonModals from "./vue/CommonComponents/CommonModals";
import { PLACE_TYPE } from "./Types/PlaceType";
//@ts-ignore
import { getPlace } from "@services/placesAPI";
//@ts-ignore
import { useFirebaseMessaging } from "@wkComposables/useFirebaseMessaging";
//@ts-ignore
import BaseIcon from "@vueEntry/UIKitComponents/BaseIcon.vue";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
// @ts-ignore
import { TREND_STATUS } from "../js/Types/TrendStatus";
// @ts-ignore
import BaseAutocomplete from "@vueEntry/UIKitComponents/BaseAutocomplete.vue";
//@ts-ignore
import { BREAKPOINT } from "@customTypes/BreakpointEnum";
// @ts-ignore
import { getCityPolygonJSON, getCountryPolygonJSON, getProvincePolygonJSON, getRegionPolygonJSON
//@ts-ignore
} from "@services/geographyAPI";
//@ts-ignore
import { getSaleGraphData as getSaleGraphDataAPI } from "@services/statisticsAPI";
//@ts-ignore
import { TOP_CITY_IDS } from "@customTypes/TopCityIdsEnum";
//@ts-ignore
import { observeOnce } from "@utils/ObserverUtils";
//@ts-ignore
import IntersectionObserverVue from "@vueEntry/IntersectionObserver/IntersectionObserverVue.vue";
//@ts-ignore
import BaseBadge from "@vueEntry/UIKitComponents/BaseBadge.vue";
//@ts-ignore
import IntersectionObservableVue from "@vueEntry/IntersectionObserver/IntersectionObservableVue.vue";
import { createApp, defineAsyncComponent } from "vue";
// eslint-disable-next-line @typescript-eslint/no-var-requires
var parser = require("wellknown");
import { mapActions, mapState, createPinia } from "pinia";
import { useLoggedUserStore, usePublicUserMenuStore, useModalStore, useBaseStore
//@ts-ignore
} from "@store/index";
//@ts-ignore
import { handleInsertionClick } from "@wkWebSrc/js/components/insertion";
//@ts-ignore
import { handleBreadcrumbLinkClick } from "@wkWebSrc/js/components/navigationBreadcrumb";
//@ts-ignore
import { transformReImages } from "@utils/ImageUtils";
//@ts-ignore
import { IMAGE_FORMATS } from "@customTypes/ImageFormatsEnum";
//@ts-ignore
import LanguageIcons from "@vueEntry/CommonComponents/LanguageIcons";
//@ts-ignore
import { useBreakpoints } from "@wkComposables/useBreakpoints";
//@ts-ignore
import { redirectToApp } from "@utils/AppRedirectUtils";
var SALE_GRAPH;
(function (SALE_GRAPH) {
  SALE_GRAPH[SALE_GRAPH["THREE_MONTHS"] = 0] = "THREE_MONTHS";
  SALE_GRAPH[SALE_GRAPH["SIX_MONTHS"] = 1] = "SIX_MONTHS";
  SALE_GRAPH[SALE_GRAPH["ONE_YEAR"] = 2] = "ONE_YEAR";
  SALE_GRAPH[SALE_GRAPH["MAX"] = 3] = "MAX";
})(SALE_GRAPH || (SALE_GRAPH = {}));
var RENT_GRAPH;
(function (RENT_GRAPH) {
  RENT_GRAPH[RENT_GRAPH["THREE_MONTHS"] = 0] = "THREE_MONTHS";
  RENT_GRAPH[RENT_GRAPH["SIX_MONTHS"] = 1] = "SIX_MONTHS";
  RENT_GRAPH[RENT_GRAPH["ONE_YEAR"] = 2] = "ONE_YEAR";
  RENT_GRAPH[RENT_GRAPH["MAX"] = 3] = "MAX";
})(RENT_GRAPH || (RENT_GRAPH = {}));
var L;
var averagePricePlace;
//TODO: da migrare a Vue
var trendSearch;
export var drawingOptions = {
  color: "#f0f0f0",
  fillOpacity: 0.7,
  weight: 2
};
export var DEF_COLOR = "#BFBFBF";
export var FILL_COLORS = {
  0: "#5e8e24",
  1: "#76B22E",
  2: "#92d049",
  3: "#ffba08",
  4: "#de7e33",
  5: "#d7263d"
};
var trendApp = createApp({
  name: "WikiTrend",
  components: Object.assign(Object.assign(Object.assign({
    PublicUserMenu,
    ValuationBanner,
    TrendBar,
    BaseBadge,
    //@ts-ignore
    cchart: defineAsyncComponent(() => import("@vueEntry/cchart.vue")),
    shimmerLoader,
    BaseAutocomplete,
    BaseIcon,
    BaseButton,
    //@ts-ignore
    SwiperCarousel: defineAsyncComponent(() => import("@vueEntry/SwiperCarousel.vue")),
    IntersectionObserverVue,
    IntersectionObservableVue
  }, CommonModals), {
    //@ts-ignore
    "async-dropdown": defineAsyncComponent(() => import("@vueEntry/UIKitComponents/BaseDropDown.vue"))
  }), LanguageIcons),
  setup() {
    var {
      isAppBannerVisible
    } = useAppBanner();
    var {
      showFirebaseSnackbar,
      snackbarTitle,
      snackbarBody,
      snackbarIcon,
      handleOnForegroundNotificationClick
    } = useFirebaseMessaging();
    var {
      isLarge
    } = useBreakpoints();
    return {
      isLarge,
      isAppBannerVisible,
      //firebaseMessaging
      showFirebaseSnackbar,
      snackbarTitle,
      snackbarBody,
      snackbarIcon,
      handleOnForegroundNotificationClick
    };
  },
  data() {
    return {
      placeLabel: {
        label: ""
      },
      trendContract: {
        sale: true,
        rent: false
      },
      isReady: false,
      trendStatus: TREND_STATUS.PRICE,
      saleGraphStatus: SALE_GRAPH.MAX,
      rentGraphStatus: RENT_GRAPH.MAX,
      trendData: true,
      trendMap: false,
      saleGraphDataResponse: [],
      saleGraphData: [],
      saleGraphDataUpdated: [],
      rentGraphDataResponse: [],
      rentGraphData: [],
      rentGraphDataUpdated: [],
      transactionGraphDataFull: [],
      transactionGraphDataLastYears: [],
      topSaleTypologiesTrend: [],
      topRentTypologiesTrend: [],
      place: JSON.parse(window["_serializedPlace"]),
      chartType: "line",
      mostRequestedTypology: {},
      yearTrendVariation: {},
      topCityList: {
        sale: [],
        rent: []
      },
      placesPricesList: {
        sale: [],
        rent: []
      },
      iconForVariation: {
        price: "euro-blu",
        request: "domanda-grigio",
        transaction: "transazione-grigio",
        sale: "",
        rent: ""
      },
      placeTrendData: null,
      placeTrendDataTempSale: null,
      placeTrendDataTempRent: null,
      sqmTrend: {},
      transactionData2020: {},
      transactionData2021: {},
      transactionPercentageChange: 0,
      transactionChartHeight: 270,
      transactionChartWidth: 300,
      cdnVar: "",
      showTransactionButton: true,
      tempStorageForTransactionsGraphData: {},
      loadingTrendYearlyVariation: false,
      loadingSqmTrend: false,
      emittedLastPositionValue: null,
      trendBgAbsolute: false,
      trendImgAbsolute: undefined,
      map: null,
      minAvg: 0,
      maxAvg: 0,
      minAvgRent: 0,
      maxAvgRent: 0,
      maxTrendSaleCicle: null,
      maxTrendRentCicle: null
    };
  },
  computed: Object.assign(Object.assign(Object.assign({
    IMAGE_FORMATS() {
      return IMAGE_FORMATS;
    },
    enumTrendStatus() {
      return TREND_STATUS;
    },
    enumSaleGraph() {
      return SALE_GRAPH;
    },
    enumRentGraph() {
      return RENT_GRAPH;
    },
    cdn() {
      return window["_cdn"];
    },
    isRegion() {
      return this.place.placeType == PLACE_TYPE.REGION;
    },
    isCountry() {
      return this.place.placeType == PLACE_TYPE.NATION;
    }
  }, mapState(useLoggedUserStore, ["isUserLogged"])), mapState(usePublicUserMenuStore, ["favoritesCounter", "requestsCounter", "savedSearchesCounter", "mailConfirmed", "name"])), mapState(useModalStore, ["showModal"])),
  created() {
    this.initPublicUserMenu();
    this.getSaleGraphData();
    this.getRentGraphData();
    this.getTopTypologiesTrend();
    this.getTrendYearlyVariation();
    this.getTopCitiesPricesList();
    this.getPlaceTrendData();
    this.getSqMTrend();
    this.getTransactionGraphData();
    this.cdnVar = this.cdn;
    this.switchValuationImg();
    this.placeLabel.label = this.place.displayName || "";
  },
  mounted() {
    var _a;
    if (window.screen.width > BREAKPOINT.SMALL) {
      this.transactionChartWidth = 570;
    } else {
      this.transactionChartHeight = 180;
    }
    (_a = document.getElementById("price-request-transaction-buttons")) === null || _a === void 0 ? void 0 : _a.addEventListener("click", event => {
      var clickedItem = event.target;
      var transactionSpan = document.getElementById("transactionSpanId");
      var transactionIcon = document.getElementById("transactionIconId");
      var headersBtns = document.getElementById("trendSwitchBtns");
      if (clickedItem == transactionSpan || clickedItem == transactionIcon) {
        headersBtns === null || headersBtns === void 0 ? void 0 : headersBtns.classList.add("tw-hidden");
      } else if (clickedItem != transactionSpan || clickedItem != transactionIcon) {
        headersBtns === null || headersBtns === void 0 ? void 0 : headersBtns.classList.remove("tw-hidden");
        // press "RENT" tab case is included into setActiveAndSwitchTab -> switch -> rent ***
      }
    });
    this.onMounted();
  },
  methods: Object.assign(Object.assign({
    useApp() {
      redirectToApp("Trend - Banner");
    },
    handleDataView() {
      this.trendData = true;
      this.trendMap = false;
    },
    handleMapView() {
      return __awaiter(this, void 0, void 0, function* () {
        this.trendData = false;
        this.trendMap = true;
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      });
    },
    transformReImages,
    handleBreadcrumbLinkClick,
    handleInsertionClick,
    formatInteger,
    showMap() {
      var _a;
      return __awaiter(this, void 0, void 0, function* () {
        yield (_a = this.map) === null || _a === void 0 ? void 0 : _a.init(this.$refs.trendMap, MAP_TILER_APIKEY, COLORS, {
          maxZoom: this.isCountry ? 8 : this.place.placeType == PLACE_TYPE.PROVINCE || this.isRegion ? 12 : 14,
          minZoom: this.isCountry ? 5 : this.place.placeType == PLACE_TYPE.PROVINCE || this.isRegion ? 7 : 9
        }, {
          latitude: this.place.latitude,
          longitude: this.place.longitude
        }, this.isCountry ? 5 : this.isRegion ? 8 : this.place.placeType == PLACE_TYPE.PROVINCE ? 10 : 11);
      });
    },
    initMap() {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        averagePricePlace = JSON.parse(_serializedAveragePricesForMap);
        var averagePrices = JSON.parse(_averagePrices);
        var averagePricesMap = {};
        var averagePricesMapRent = {};
        var placesList = {};
        averagePrices.forEach(price => {
          if (price) {
            placesList[this.isCountry ? price.place.regionID : this.isRegion ? price.place.provinceID : _hasZones ? price.place.zoneID : price.place.cityID] = price;
            // eslint-disable-next-line max-len
            averagePricesMap[this.isCountry ? price.place.regionID : this.isRegion ? price.place.provinceID : _hasZones ? price.place.zoneID : price.place.cityID] = price.residentialAverageSale;
            if (!this.minAvg && price.residentialAverageSale) this.minAvg = price.residentialAverageSale;
            if (!this.maxAvg && price.residentialAverageSale) this.maxAvg = price.residentialAverageSale;
            if (price.residentialAverageSale && price.residentialAverageSale < this.minAvg) this.minAvg = price.residentialAverageSale;
            if (price.residentialAverageSale && price.residentialAverageSale > this.maxAvg) this.maxAvg = price.residentialAverageSale;
            // placesList[isCountry ? price.place.regionID : isRegion ? price.place.provinceID : _hasZones ? price.place.zoneID : price.place.cityID] = price;
            // eslint-disable-next-line max-len
            averagePricesMapRent[this.isCountry ? price.place.regionID : this.isRegion ? price.place.provinceID : _hasZones ? price.place.zoneID : price.place.cityID] = price.residentialAverageRent;
            if (!this.minAvgRent && price.residentialAverageRent) this.minAvgRent = price.residentialAverageRent;
            if (!this.maxAvgRent && price.residentialAverageRent) this.maxAvgRent = price.residentialAverageRent;
            if (price.residentialAverageRent && price.residentialAverageRent < this.minAvgRent) this.minAvgRent = price.residentialAverageRent;
            if (price.residentialAverageRent && price.residentialAverageRent > this.maxAvgRent) this.maxAvgRent = price.residentialAverageRent;
          }
        });
        //@ts-ignore
        var LeafletModule = yield import("@wkWebSrc/js/LeafletMap/leaflet_map");
        var leaflet = LeafletModule.default;
        //@ts-ignore
        L = yield import( /* webpackChunkName: "chunks/leaflet" */"leaflet/src/Leaflet");
        this.map = new leaflet();
        try {
          yield this.showMap();
          var jsonPolygon = this.isCountry ? yield getCountryPolygonJSON(this.place.countryID) : this.isRegion ? yield getRegionPolygonJSON(this.place.regionID) : _hasZones ? yield getCityPolygonJSON(this.place.cityID) : yield getProvincePolygonJSON(this.place.provinceID);
          var features = this.isRegion || this.isCountry ? JSON.parse(jsonPolygon.polygonList) : jsonPolygon.polygonList;
          var clickData = JSON.parse(_serializedClickData);
          var clickDataRent = JSON.parse(_serializedClickDataRent);
          var mapContainer = document.getElementById("trend-map-container");
          var priceLayers = [];
          var priceLayersRent = [];
          var clickLayers = [];
          var clickLayersRent = [];
          features.forEach((feature, i) => {
            var p = placesList[this.isCountry ? feature.regionId : this.isRegion ? feature.provinceId : _hasZones ? feature.zoneId : feature.cityId];
            var url = _hasZones ? "".concat(_baseURL, "/").concat(_trendURL, "/").concat(p.place.cityURL, "/").concat(p.place.zoneURL, "/") : "".concat(_baseURL, "/").concat(_trendURL, "/").concat(p.place.urlPartName, "/");
            // le prossime 3 righe contengono informagica(tm), non toccare
            var popup = null;
            if (p) popup = L.popup().setContent(this.buildPopupContent(p, url));
            var priceLayer = L.geoJSON(parser(feature.polygon), {
              style: () => {
                // eslint-disable-next-line max-len
                var average = averagePricesMap[this.isCountry ? feature.regionId : this.isRegion ? feature.provinceId : _hasZones ? feature.zoneId : feature.cityId];
                return Object.assign(Object.assign({}, drawingOptions), {
                  fillColor: this.calcFillColor({
                    avg: average,
                    min: this.minAvg,
                    max: this.maxAvg,
                    medium: averagePricePlace.residentialAverageSale,
                    steps: 4
                  })
                });
              }
            }).addTo(this.map.getMap());
            var priceLayerRent = L.geoJSON(parser(feature.polygon), {
              style: () => {
                // eslint-disable-next-line max-len
                var average = averagePricesMapRent[this.isCountry ? feature.regionId : this.isRegion ? feature.provinceId : _hasZones ? feature.zoneId : feature.cityId];
                return Object.assign(Object.assign({}, drawingOptions), {
                  fillColor: this.calcFillColor({
                    avg: average,
                    medium: averagePricePlace.residentialAverageRent,
                    min: this.minAvgRent,
                    max: this.maxAvgRent,
                    steps: 4
                  })
                });
              }
            });
            if (popup) {
              priceLayer.bindPopup(popup);
              if (!this.isCountry && !this.isRegion && (_hasZones && this.place.zoneID == feature.zoneId || !_hasZones && this.place.cityID == feature.cityId)) priceLayer.openPopup();
            }
            if (popup) priceLayerRent.bindPopup(popup);
            var trendPopup = L.popup().setContent(this.buildPopupTrendContent(p, url, clickData, feature));
            var requestLayer = L.geoJSON(parser(feature.polygon), {
              style: () => {
                var clickCount = clickData[this.isCountry ? feature.regionId : this.isRegion ? feature.provinceId : _hasZones ? feature.zoneId : feature.cityId];
                return Object.assign(Object.assign({}, drawingOptions), {
                  fillColor: this.calcFillColor({
                    avg: clickCount,
                    medium: _avgClick,
                    min: _minClick,
                    max: _maxClick,
                    steps: 3
                  })
                });
              }
            });
            requestLayer.bindPopup(trendPopup);
            var requestLayerRent = L.geoJSON(parser(feature.polygon), {
              style: () => {
                // eslint-disable-next-line max-len
                var clickCount = clickDataRent[this.isCountry ? feature.regionId : this.isRegion ? feature.provinceId : _hasZones ? feature.zoneId : feature.cityId];
                return Object.assign(Object.assign({}, drawingOptions), {
                  fillColor: this.calcFillColor({
                    avg: clickCount,
                    min: _minClickRent,
                    max: _maxClickRent,
                    medium: _avgClickRent,
                    steps: 3
                  })
                });
              }
            });
            requestLayerRent.bindPopup(trendPopup);
            priceLayers.push(priceLayer);
            priceLayersRent.push(priceLayerRent);
            clickLayers.push(requestLayer);
            clickLayersRent.push(requestLayerRent);
          });
          (_a = document.getElementById("price-request-transaction-buttons")) === null || _a === void 0 ? void 0 : _a.addEventListener("click", event => {
            var _a, _b, _c;
            var price = (_a = document.getElementById("trendPriceBtn")) === null || _a === void 0 ? void 0 : _a.classList.contains("active");
            var saleStatus = (_b = document.getElementById("trendSaleBtn")) === null || _b === void 0 ? void 0 : _b.classList.contains("active");
            var rentStatus = (_c = document.getElementById("trendRentBtn")) === null || _c === void 0 ? void 0 : _c.classList.contains("active");
            if (price) {
              clickLayers.forEach(layer => {
                this.map.getMap().removeLayer(layer);
              });
              clickLayersRent.forEach(layer => {
                this.map.getMap().removeLayer(layer);
              });
              if (saleStatus) {
                priceLayers.forEach(layer => {
                  this.map.getMap().addLayer(layer);
                });
                priceLayersRent.forEach(layer => {
                  this.map.getMap().removeLayer(layer);
                });
              } else if (rentStatus) {
                priceLayers.forEach(layer => {
                  this.map.getMap().removeLayer(layer);
                });
                priceLayersRent.forEach(layer => {
                  this.map.getMap().addLayer(layer);
                });
              }
            } else if (!price) {
              priceLayers.forEach(layer => {
                this.map.getMap().removeLayer(layer);
              });
              priceLayersRent.forEach(layer => {
                this.map.getMap().removeLayer(layer);
              });
              if (saleStatus) {
                clickLayers.forEach(layer => {
                  this.map.getMap().addLayer(layer);
                });
                clickLayersRent.forEach(layer => {
                  this.map.getMap().removeLayer(layer);
                });
              } else if (rentStatus) {
                clickLayersRent.forEach(layer => {
                  this.map.getMap().addLayer(layer);
                });
                clickLayers.forEach(layer => {
                  this.map.getMap().removeLayer(layer);
                });
              }
            }
          });
          (_b = document.getElementById("sale-rent-button-trend")) === null || _b === void 0 ? void 0 : _b.addEventListener("click", event => {
            var _a, _b, _c;
            var price = (_a = document.getElementById("trendPriceBtn")) === null || _a === void 0 ? void 0 : _a.classList.contains("active");
            var saleStatus = (_b = document.getElementById("trendSaleBtn")) === null || _b === void 0 ? void 0 : _b.classList.contains("active");
            var rentStatus = (_c = document.getElementById("trendRentBtn")) === null || _c === void 0 ? void 0 : _c.classList.contains("active");
            if (saleStatus) {
              priceLayersRent.forEach(layer => {
                this.map.getMap().removeLayer(layer);
              });
              clickLayersRent.forEach(layer => {
                this.map.getMap().removeLayer(layer);
              });
              if (price) {
                priceLayers.forEach(layer => {
                  this.map.getMap().addLayer(layer);
                });
                clickLayers.forEach(layer => {
                  this.map.getMap().removeLayer(layer);
                });
              } else {
                priceLayers.forEach(layer => {
                  this.map.getMap().removeLayer(layer);
                });
                clickLayers.forEach(layer => {
                  this.map.getMap().addLayer(layer);
                });
              }
            } else if (rentStatus) {
              priceLayers.forEach(layer => {
                this.map.getMap().removeLayer(layer);
              });
              clickLayers.forEach(layer => {
                this.map.getMap().removeLayer(layer);
              });
              if (price) {
                priceLayersRent.forEach(layer => {
                  this.map.getMap().addLayer(layer);
                });
                clickLayersRent.forEach(layer => {
                  this.map.getMap().removeLayer(layer);
                });
              } else {
                priceLayersRent.forEach(layer => {
                  this.map.getMap().removeLayer(layer);
                });
                clickLayersRent.forEach(layer => {
                  this.map.getMap().addLayer(layer);
                });
              }
            }
          });
        } catch (e) {
          console.error(e);
        }
      });
    },
    onMounted() {
      return __awaiter(this, void 0, void 0, function* () {
        var filters = {
          macroTypologyId: 1,
          sale: true,
          rent: false
        };
        var agencyFilters = {
          latitude: this.place.latitude,
          longitude: this.place.longitude,
          placeType: this.place.placeType,
          placeId: this.place.placeID
        };
        switch (this.place.placeType) {
          case "N":
            filters.countryId = this.place.countryID;
            agencyFilters.countryId = this.place.countryID;
            break;
          case "R":
            filters.regionId = this.place.regionID;
            agencyFilters.regionId = this.place.regionID;
            break;
          case "P":
            filters.provinceId = this.place.provinceID;
            agencyFilters.provinceId = this.place.provinceID;
            break;
          case "C":
            filters.cityId = this.place.cityID;
            agencyFilters.cityId = this.place.cityID;
            break;
          case "Z":
            filters.cityId = this.place.cityID;
            filters.zoneId = this.place.zoneID;
            agencyFilters.cityId = this.place.cityID;
            agencyFilters.zoneId = this.place.zoneID;
            break;
        }
        observeOnce("#map", () => {
          this.initMap();
        });
      });
    },
    callbackFn(v) {
      return __awaiter(this, void 0, void 0, function* () {
        if (!v) return;
        var res = yield getPlace(v);
        //@ts-ignore
        return res.map((place, index) => ({
          id: index,
          label: place.displayName,
          payload: place
        }));
      });
    },
    handleSelection(opt) {
      var _a;
      var cityURL = (_a = opt === null || opt === void 0 ? void 0 : opt.payload) === null || _a === void 0 ? void 0 : _a.completeURL;
      window.location.href = "".concat(_baseURL, "/").concat(_trendURL, "/").concat(cityURL, "/");
    },
    handleEmittedPosition(e) {
      this.emittedLastPositionValue = e;
      this.injectPlaceTrendData();
    },
    getSaleGraphData() {
      return __awaiter(this, void 0, void 0, function* () {
        this.saleGraphDataResponse = yield getSaleGraphDataAPI(this.place, {
          contract: "sale",
          macroTypologyId: 1
        });
        this.saleGraphData = this.saleGraphDataResponse;
      });
    },
    getRentGraphData() {
      var filters = {
        contract: "rent",
        macroTypologyId: 1
      };
      axios.post("/rest/statistics/getAveragePriceGraphData/".concat(filters.contract, "/").concat(filters.macroTypologyId), this.place, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        }
      }).then(response => {
        this.rentGraphDataResponse = response.data;
        this.rentGraphData = this.rentGraphDataResponse;
      });
    },
    getTransactionGraphData() {
      axios.post("/rest/insights/getTransactionsGraphData", this.place, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        }
      }).then(response => {
        if (response.data.some(data => {
          return data.value < 0;
        })) {
          this.showTransactionButton = false;
        } else this.tempStorageForTransactionsGraphData = response.data;
      });
    },
    getTopTypologiesTrend() {
      axios.all([axios.post("/rest/statistics/getTopTypologiesTrend?sale=".concat(true), this.place, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        }
      }), axios.post("/rest/statistics/getTopTypologiesTrend?sale=".concat(false), this.place, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        }
      })]).then(axios.spread((saleResponse, rentResponse) => {
        this.topSaleTypologiesTrend = saleResponse.data;
        this.mostRequestedTypology.sale = saleResponse.data[0];
        this.topRentTypologiesTrend = rentResponse.data;
        this.mostRequestedTypology.rent = rentResponse.data[0];
      }));
    },
    getTrendYearlyVariation() {
      this.loadingTrendYearlyVariation = true;
      axios.all([axios.post("/rest/statistics/getTrendYearlyVariation?sale=".concat(true), this.place, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        }
      }), axios.post("/rest/statistics/getTrendYearlyVariation?sale=".concat(false), this.place, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        }
      })]).then(axios.spread((yearTrendVariationSaleResponse, yearTrendVariationRentResponse) => {
        this.yearTrendVariation.sale = Math.round(yearTrendVariationSaleResponse.data);
        this.yearTrendVariation.rent = Math.round(yearTrendVariationRentResponse.data);
        this.convertVariationToIcon(this.yearTrendVariation.sale, true);
        this.convertVariationToIcon(this.yearTrendVariation.rent, false);
        this.loadingTrendYearlyVariation = false;
      }));
    },
    createPercentageChange(a, b) {
      var percent;
      if (b !== 0) {
        if (a !== 0) {
          percent = (b - a) / a * 100;
        } else {
          percent = b * 100;
        }
      } else {
        percent = -a * 100;
      }
      return Math.floor(percent);
    },
    convertVariationToIcon(n, sale) {
      var icon;
      if (n >= 6) {
        icon = "freccia-verde-3";
      } else if (n > 4) {
        icon = "freccia-verde-2";
      } else if (n > 2) {
        icon = "freccia-verde-1";
      } else if (n > -2) {
        icon = "uguale-giallo";
      } else if (n > -4) {
        icon = "freccia-rossa-1";
      } else if (n > -6) {
        icon = "freccia-rossa-2";
      } else if (n <= -6) {
        icon = "freccia-rossa-3";
      }
      if (sale) {
        this.iconForVariation.sale = icon;
      } else {
        this.iconForVariation.rent = icon;
      }
    },
    getTopCitiesPricesList() {
      axios.all([axios.get("/rest/statistics/getTopCitiesPricesList?sale=".concat(true), this.place), axios.get("/rest/statistics/getTopCitiesPricesList?sale=".concat(false), this.place)]).then(axios.spread((responseTopCitySale, responseTopCityRent) => {
        this.topCityList.sale = responseTopCitySale.data;
        this.topCityList.sale.forEach(object => {
          object.averagePrice = formatInteger(object.averagePrice);
        });
        this.topCityList.rent = responseTopCityRent.data;
        this.topCityList.rent.forEach(object => {
          object.averagePrice = formatFloat(object.averagePrice);
        });
      }));
    },
    getPlaceTrendData() {
      axios.all([axios.post("/rest/statistics/getPlaceTrendData?sale=".concat(true), this.place), axios.post("/rest/statistics/getPlaceTrendData?sale=".concat(false), this.place)]).then(axios.spread((responseSale, responseRent) => {
        this.placeTrendDataTempSale = responseSale.data;
        this.placeTrendDataTempRent = responseRent.data;
        this.injectPlaceTrendData();
      }));
    },
    getSqMTrend() {
      this.loadingSqmTrend = true;
      axios.post("/rest/statistics/getSqMTrend", this.place, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        }
      }).then(response => {
        this.loadingSqmTrend = false;
        this.sqmTrend.sale = response.data.sale;
        this.sqmTrend.rent = response.data.rent;
      });
    },
    injectPlaceTrendData() {
      if (this.trendStatus === TREND_STATUS.REQUEST) {
        if (this.trendContract.sale) {
          if (this.emittedLastPositionValue != null) {
            this.placeTrendData = this.emittedLastPositionValue;
            setTimeout(() => {
              this.placeTrendData = this.placeTrendDataTempSale;
            }, 50);
          } else {
            this.placeTrendData = this.placeTrendDataTempSale;
          }
        } else {
          if (this.emittedLastPositionValue != null) {
            this.placeTrendData = this.emittedLastPositionValue;
            setTimeout(() => {
              this.placeTrendData = this.placeTrendDataTempRent;
            }, 50);
          } else {
            this.placeTrendData = this.placeTrendDataTempRent;
          }
        }
      } else {
        this.placeTrendData = null;
      }
    },
    fillTransactionGraphData(tempData) {
      this.transactionGraphDataFull = tempData;
      this.transactionGraphDataLastYears = tempData.slice(Math.max(tempData.length - 2));
      this.transactionData2020 = this.transactionGraphDataLastYears[0];
      this.transactionData2021 = this.transactionGraphDataLastYears[1];
      // [(Xf - Xi)/ Xi ] x 100
      this.transactionPercentageChange = this.createPercentageChange(this.transactionData2020.value, this.transactionData2021.value);
    },
    switchValuationImg() {
      if (Object.values(TOP_CITY_IDS).indexOf(this.place.cityID) === -1) {
        this.trendBgAbsolute = true; // TODO:
      }
    },
    setActiveAndSwitchTab(ref) {
      var _a, _b, _c, _d;
      ref.classList.add("active");
      var sale = this.$refs.saleBtn;
      var rent = this.$refs.rentBtn;
      var mapContainer = document.getElementById("trend-map-container");
      var price = this.$refs.priceBtn;
      var request = this.$refs.requestBtn;
      var transaction = this.$refs.transactionBtn;
      var headersBtns = document.getElementById("trendSwitchBtns");
      var btnMinMonthSale = this.$refs.btnMinMonthSale;
      var btnMonthSale = this.$refs.btnMonthSale;
      var btnYearSale = this.$refs.btnYearSale;
      var btnMaxSale = this.$refs.btnMaxSale;
      var btnMinMonthRent = this.$refs.btnMinMonthRent;
      var btnMonthRent = this.$refs.btnMonthRent;
      var btnYearRent = this.$refs.btnYearRent;
      var btnMaxRent = this.$refs.btnMaxRent;
      switch (ref) {
        case sale:
          rent === null || rent === void 0 ? void 0 : rent.classList.remove("active");
          mapContainer === null || mapContainer === void 0 ? void 0 : mapContainer.classList.remove("rent-active");
          mapContainer === null || mapContainer === void 0 ? void 0 : mapContainer.classList.add("sale-active");
          this.trendContract.sale = true;
          this.trendContract.rent = false;
          // this.injectPlaceTrendData();
          break;
        case rent:
          sale === null || sale === void 0 ? void 0 : sale.classList.remove("active");
          mapContainer === null || mapContainer === void 0 ? void 0 : mapContainer.classList.remove("sale-active");
          mapContainer === null || mapContainer === void 0 ? void 0 : mapContainer.classList.add("rent-active");
          this.trendContract.sale = false;
          this.trendContract.rent = true;
          headersBtns === null || headersBtns === void 0 ? void 0 : headersBtns.classList.remove("tw-hidden"); // *** show again the HEADER's buttons
          (_a = document.getElementById("trend-container")) === null || _a === void 0 ? void 0 : _a.classList.remove("trend-transactions");
          if (this.trendStatus == TREND_STATUS.TRANSACTION) this.trendStatus = TREND_STATUS.PRICE;
          break;
        // PRICE REQUEST TRASACTION
        case price:
          request === null || request === void 0 ? void 0 : request.classList.remove("active");
          transaction === null || transaction === void 0 ? void 0 : transaction.classList.remove("active");
          this.iconForVariation.price = "euro-blu";
          this.iconForVariation.request = "domanda-grigio";
          this.iconForVariation.transaction = "transazione-grigio";
          (_b = document.getElementById("trend-container")) === null || _b === void 0 ? void 0 : _b.classList.remove("trend-transactions");
          this.trendStatus = TREND_STATUS.PRICE;
          break;
        case request:
          price === null || price === void 0 ? void 0 : price.classList.remove("active");
          transaction === null || transaction === void 0 ? void 0 : transaction.classList.remove("active");
          this.iconForVariation.price = "euro-grigio";
          this.iconForVariation.request = "domanda-blu";
          this.iconForVariation.transaction = "transazione-grigio";
          (_c = document.getElementById("trend-container")) === null || _c === void 0 ? void 0 : _c.classList.remove("trend-transactions");
          this.trendStatus = TREND_STATUS.REQUEST;
          this.injectPlaceTrendData();
          break;
        case transaction:
          price === null || price === void 0 ? void 0 : price.classList.remove("active");
          request === null || request === void 0 ? void 0 : request.classList.remove("active");
          this.fillTransactionGraphData(this.tempStorageForTransactionsGraphData);
          this.iconForVariation.price = "euro-grigio";
          this.iconForVariation.request = "domanda-grigio";
          this.iconForVariation.transaction = "transazione-blu";
          (_d = document.getElementById("trend-container")) === null || _d === void 0 ? void 0 : _d.classList.add("trend-transactions");
          this.trendStatus = TREND_STATUS.TRANSACTION;
          break;
        // SALE 3 MONTH - 6 MONTH - 1 YEAR - MAX
        case btnMinMonthSale:
          btnMonthSale === null || btnMonthSale === void 0 ? void 0 : btnMonthSale.classList.remove("active");
          btnYearSale === null || btnYearSale === void 0 ? void 0 : btnYearSale.classList.remove("active");
          btnMaxSale === null || btnMaxSale === void 0 ? void 0 : btnMaxSale.classList.remove("active");
          this.saleGraphDataUpdated = this.saleGraphDataResponse.slice(Math.max(this.saleGraphDataResponse.length - 3));
          this.saleGraphData = this.saleGraphDataUpdated;
          this.saleGraphStatus = SALE_GRAPH.THREE_MONTHS;
          break;
        case btnMonthSale:
          btnMinMonthSale === null || btnMinMonthSale === void 0 ? void 0 : btnMinMonthSale.classList.remove("active");
          btnYearSale === null || btnYearSale === void 0 ? void 0 : btnYearSale.classList.remove("active");
          btnMaxSale === null || btnMaxSale === void 0 ? void 0 : btnMaxSale.classList.remove("active");
          this.saleGraphDataUpdated = this.saleGraphDataResponse.slice(Math.max(this.saleGraphDataResponse.length - 6));
          this.saleGraphData = this.saleGraphDataUpdated;
          this.saleGraphStatus = SALE_GRAPH.SIX_MONTHS;
          break;
        case btnYearSale:
          btnMinMonthSale === null || btnMinMonthSale === void 0 ? void 0 : btnMinMonthSale.classList.remove("active");
          btnMonthSale === null || btnMonthSale === void 0 ? void 0 : btnMonthSale.classList.remove("active");
          btnMaxSale === null || btnMaxSale === void 0 ? void 0 : btnMaxSale.classList.remove("active");
          this.saleGraphDataUpdated = this.saleGraphDataResponse.slice(Math.max(this.saleGraphDataResponse.length - 12));
          this.saleGraphData = this.saleGraphDataUpdated;
          this.saleGraphStatus = SALE_GRAPH.ONE_YEAR;
          break;
        case btnMaxSale:
          btnMinMonthSale === null || btnMinMonthSale === void 0 ? void 0 : btnMinMonthSale.classList.remove("active");
          btnMonthSale === null || btnMonthSale === void 0 ? void 0 : btnMonthSale.classList.remove("active");
          btnYearSale === null || btnYearSale === void 0 ? void 0 : btnYearSale.classList.remove("active");
          this.getSaleGraphData();
          this.saleGraphStatus = SALE_GRAPH.MAX;
          break;
        // RENT 3 MONTH - 6 MONTH - 1 YEAR - MAX
        case btnMinMonthRent:
          btnMonthRent === null || btnMonthRent === void 0 ? void 0 : btnMonthRent.classList.remove("active");
          btnYearRent === null || btnYearRent === void 0 ? void 0 : btnYearRent.classList.remove("active");
          btnMaxRent === null || btnMaxRent === void 0 ? void 0 : btnMaxRent.classList.remove("active");
          this.rentGraphDataUpdated = this.rentGraphDataResponse.slice(Math.max(this.rentGraphDataResponse.length - 3));
          this.rentGraphData = this.rentGraphDataUpdated;
          this.rentGraphStatus = RENT_GRAPH.THREE_MONTHS;
          break;
        case btnMonthRent:
          btnMinMonthRent === null || btnMinMonthRent === void 0 ? void 0 : btnMinMonthRent.classList.remove("active");
          btnYearRent === null || btnYearRent === void 0 ? void 0 : btnYearRent.classList.remove("active");
          btnMaxRent === null || btnMaxRent === void 0 ? void 0 : btnMaxRent.classList.remove("active");
          this.rentGraphDataUpdated = this.rentGraphDataResponse.slice(Math.max(this.rentGraphDataResponse.length - 6));
          this.rentGraphData = this.rentGraphDataUpdated;
          this.rentGraphStatus = RENT_GRAPH.SIX_MONTHS;
          break;
        case btnYearRent:
          btnMinMonthRent === null || btnMinMonthRent === void 0 ? void 0 : btnMinMonthRent.classList.remove("active");
          btnMonthRent === null || btnMonthRent === void 0 ? void 0 : btnMonthRent.classList.remove("active");
          btnMaxRent === null || btnMaxRent === void 0 ? void 0 : btnMaxRent.classList.remove("active");
          this.rentGraphDataUpdated = this.rentGraphDataResponse.slice(Math.max(this.rentGraphDataResponse.length - 12));
          this.rentGraphData = this.rentGraphDataUpdated;
          this.rentGraphStatus = RENT_GRAPH.ONE_YEAR;
          break;
        case btnMaxRent:
          btnMinMonthRent === null || btnMinMonthRent === void 0 ? void 0 : btnMinMonthRent.classList.remove("active");
          btnMonthRent === null || btnMonthRent === void 0 ? void 0 : btnMonthRent.classList.remove("active");
          btnYearRent === null || btnYearRent === void 0 ? void 0 : btnYearRent.classList.remove("active");
          this.getRentGraphData();
          this.rentGraphStatus = RENT_GRAPH.MAX;
          break;
        default:
          console.log("Default");
      }
    },
    calcFillColor(props) {
      var {
        avg,
        min,
        max,
        medium,
        steps
      } = props;
      if (!avg) return DEF_COLOR;
      var lowerStep = (medium - min) / steps;
      var upperStep = (max - medium) / steps;
      if (avg < medium - lowerStep * 2) return FILL_COLORS[0];
      if (avg < medium - lowerStep) return FILL_COLORS[1];
      if (avg < medium) return FILL_COLORS[2];
      if (avg < medium + upperStep) return FILL_COLORS[3];
      if (avg < medium + upperStep * 2) return FILL_COLORS[4];
      return FILL_COLORS[5];
    },
    buildPopupContent(pricePlace, url) {
      var place = pricePlace.place;
      var popupFragment = document.createDocumentFragment();
      // eslint-disable-next-line max-len
      popupFragment.append("<p class=\"tw-font-semibold tw-mb-10px\">".concat(this.isCountry ? place.regionName : this.isRegion ? place.provinceName : _hasZones ? place.zoneName : place.cityName, "</p>"));
      if (!pricePlace.residentialAverageSale && !pricePlace.residentialAverageRent)
        // elem.append(`<p>${_dataNotAvailableLabel}</p>`)
        popupFragment.append("<p>".concat(_dataNotAvailableLabel, "</p>"));else {
        if (pricePlace.residentialAverageSale) {
          // eslint-disable-next-line max-len
          popupFragment.append("<p class=\"show-on-sale\">".concat(_averagePriceSaleLabel, " <span class=\"tw-font-semibold\">").concat(formatInteger(pricePlace.residentialAverageSale, true), "</span> &euro;/m<sup>2</sup></p>"));
        }
        if (pricePlace.residentialAverageRent) {
          // eslint-disable-next-line max-len
          popupFragment.append("<p class=\"show-on-rent\">".concat(_averagePriceRentLabel, " <span class=\"tw-font-semibold\">").concat(formatFloat(pricePlace.residentialAverageRent), "</span> &euro;/m<sup>2</sup></p>"));
        }
        // eslint-disable-next-line max-len
        popupFragment.append("<a href=\"".concat(url, "\" class=\"tw-capitalize tw-font-semibold tw-block tw-mt-10px !tw-text-w-primary\">").concat(this.isCountry ? _viewRegionDataLabel : this.isRegion ? _viewProvinceDataLabel : _hasZones ? _viewZoneDataLabel : _viewDataLabel, "</a>"));
      }
      return "<div class=\"tw-p-15px tw-text-center\">".concat(popupFragment.textContent, "</div>");
    },
    buildPopupTrendContent(p, url, clickData, feature) {
      var clickCount = clickData[this.isCountry ? feature.regionId : this.isRegion ? feature.provinceId : _hasZones ? feature.zoneId : feature.cityId];
      var popupFragment = document.createDocumentFragment();
      if (!clickCount) {
        // eslint-disable-next-line max-len
        popupFragment.append("<span class=\"tw-text-16 tw-font-semibold\">".concat(this.isCountry ? p.place.regionName : this.isRegion ? p.place.provinceName : _hasZones ? p.place.zoneName : p.place.cityName, "</span>"));
      } else {
        // eslint-disable-next-line max-len
        popupFragment.append("<a href=\"".concat(url, "\" class=\"tw-text-16 tw-font-semibold\">").concat(this.isCountry ? p.place.regionName : this.isRegion ? p.place.provinceName : _hasZones ? p.place.zoneName : p.place.cityName, "</a>"));
      }
      return "<div class=\"tw-p-10px tw-text-center\">".concat(popupFragment.textContent, "</div>");
    }
  }, mapActions(useModalStore, ["setShowModal"])), mapActions(useBaseStore, ["logout", "initPublicUserMenu"]))
});
trendApp.use(createPinia());
trendApp.mount("#trend-main");